"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkControlType = checkControlType;

var _isUndefined2 = _interopRequireDefault(require("lodash/isUndefined"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Check to make sure component is not controlled and uncontrolled at the same time
 * @param {object} props - Component props
 * @param {string} propName - Name of prop
 * @returns {Error|undefined} - Returns error if component is both controlled and uncontrolled
 */
function checkControlType(props, propName) {
  var upperCaseFirstLetter = propName.charAt(0).toUpperCase() + propName.slice(1);
  var defaultValuePropName = "default".concat(upperCaseFirstLetter);
  var defaultValue = props[defaultValuePropName];
  var value = props[propName];

  if (!(0, _isUndefined2.default)(defaultValue) && !(0, _isUndefined2.default)(value)) {
    return new Error("".concat(propName, " and ").concat(defaultValuePropName, " should not be defined together. ") + "".concat(propName, " is for controlled component and ").concat(defaultValuePropName, " is for uncontrolled"));
  }
}